export function isPostcodeValid(postcode: string): boolean {
    const regExPostCodeValidator = /^[a-z]{1,2}\d[\da-z]? ?\d[a-z]{2}$/i;
    return regExPostCodeValidator.test(postcode);
}
